import React, { useRef } from 'react'
import { Text, HStack } from '@chakra-ui/react'
import { Button, ButtonProps } from '@chakra-ui/react'
import { CheckIcon, ChevronDownIcon } from '@chakra-ui/icons'
import { Menu, MenuList, MenuItem, MenuButton } from '@chakra-ui/react'
import SharedStack from '~components/shared/wrappers/shared-stack'

type Props = {
    value: string
    onChange: (input: string) => void
    placeholder?: string
    options: {
        value: string
        label: string
        leftElement?: any
        rightElement?: any
    }[]
    buttonOverrides?: ButtonProps
    renderValue?: (value: string) => React.ReactNode
}

function MenuSelect({
    options,
    value,
    onChange,
    placeholder,
    buttonOverrides,
    renderValue,
}: Props) {
    const buttonRef = useRef<HTMLButtonElement>(null)

    return (
        <Menu placement="bottom">
            <MenuButton
                as={Button}
                ref={buttonRef}
                variant="outline"
                rightIcon={<ChevronDownIcon />}
                textAlign="left"
                fontWeight="normal"
                bg="white"
                _dark={{
                    bg: 'gray.800',
                }}
                {...buttonOverrides}
            >
                {renderValue
                    ? renderValue(value)
                    : options.find(o => o.value === value)?.label ||
                      placeholder ||
                      'Select an option'}
            </MenuButton>
            <MenuList
                maxH="478px"
                overflowY="scroll"
                w={`${buttonRef.current?.clientWidth}px`}
            >
                {options.map(o => {
                    const isSelected = o.value === value
                    return (
                        <MenuItem
                            key={o.value}
                            onClick={() => onChange(o.value)}
                        >
                            <SharedStack
                                row
                                align="center"
                                justify="space-between"
                            >
                                <HStack>
                                    {o.leftElement}
                                    <Text>{o.label}</Text>
                                    {o.rightElement}
                                </HStack>
                                {isSelected && <CheckIcon />}
                            </SharedStack>
                        </MenuItem>
                    )
                })}
            </MenuList>
        </Menu>
    )
}

export default MenuSelect
